import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { createUser } from '../features/users/userSlice'

function CreateUser() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        type: '',
        status: '',
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        phone: '',
        company: '',
        business_address: '',
        business_suburb: '',
        business_postcode: '',
        business_state: '',
        postal_check: '',
        postal_address: '',
        postal_suburb: '',
        postal_postcode: '',
        postal_state: '',
        // type: 'user',
        // status: '1',
        // email: 'someone@somewhere.com',
        // password: 'password',
        // firstname: 'John',
        // lastname: 'Smith',
        // phone: '01234567890',
        // company: 'ACME',
        // business_address: '1 Somewhere St',
        // business_suburb: 'Melbourne',
        // business_postcode: '3000',
        // business_state: 'VIC',
        // postal_check: '1',
        // postal_address: '100 Somewhere St',
        // postal_suburb: 'Melbourne West',
        // postal_postcode: '3001',
        // postal_state: 'NSW',
    })

    const {
        type,
        status,
        email,
        password,
        firstname,
        lastname,
        phone,
        company,
        business_address,
        business_suburb,
        business_postcode,
        business_state,
        postal_check,
        postal_address,
        postal_suburb,
        postal_postcode,
        postal_state
    } = formData

    const roles = [
        {
            label: 'Admin',
            value: 'admin'
        },
        {
            label: 'User',
            value: 'user'
        }
    ]

    const statuses = [
        {
            label: 'Active',
            value: '1'
        },
        {
            label: 'Disabled',
            value: '0'
        }
    ]

    const states = [
        'NSW',
        'VIC'
    ]

    const onSubmit = async (e) => {
        e.preventDefault()

        dispatch(createUser(formData))
        toast.success('Created')
        navigate('/users')
    }

    const onMutate = (e) => {
        let boolean = null

        if(e.target.value === 'true') {
            boolean = true
        }

        if(e.target.value === 'false') {
            boolean = false
        }

        if(e.target.id === 'postal_check') {
            boolean = e.target.checked
        }

        setFormData((prevState) => ({
            ...prevState,
            [e.target.id]: boolean ?? e.target.value,
        }))
    }

    return (
        <>
            <h1 className="pageTitle">Create User</h1>

            <form className='form' onSubmit={onSubmit}>

                <div className='form-group'>
                    <label className='form-label'>Type</label>
                    <select
                        className='form-control'
                        id='type'
                        value={type}
                        onChange={onMutate}
                        required
                    >
                        {roles.map((role, index) => (
                            <option key={index} value={role.value}>{role.label}</option>
                        ))}
                    </select>
                </div>

                <div className='form-group'>
                    <label className='form-label'>Status</label>
                    <select
                        className='form-control'
                        id='status'
                        value={status}
                        onChange={onMutate}
                        required
                    >
                        {statuses.map((status, index) => (
                            <option key={index} value={status.value}>{status.label}</option>
                        ))}
                    </select>
                </div>

                <div className='form-group'>
                    <label className='form-label'>Email</label>
                    <input
                        className='form-control'
                        type='email'
                        id='email'
                        value={email}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Password</label>
                    <input
                        className='form-control'
                        type='password'
                        id='password'
                        value={password}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>First Name</label>
                    <input
                        className='form-control'
                        type='text'
                        id='firstname'
                        value={firstname}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Last Name</label>
                    <input
                        className='form-control'
                        type='text'
                        id='lastname'
                        value={lastname}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Phone</label>
                    <input
                        className='form-control'
                        type='text'
                        id='phone'
                        value={phone}
                        onChange={onMutate}
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Company</label>
                    <input
                        className='form-control'
                        type='text'
                        id='company'
                        value={company}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Business Address</label>
                    <input
                        className='form-control'
                        type='text'
                        id='business_address'
                        value={business_address}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Business Suburb</label>
                    <input
                        className='form-control'
                        type='text'
                        id='business_suburb'
                        value={business_suburb}
                        onChange={onMutate}
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Business State</label>
                    <select
                        className='form-control'
                        id='business_state'
                        value={business_state}
                        onChange={onMutate}
                        required
                    >
                        {states.map((state, index) => (
                            <option key={index} value={state}>{state}</option>
                        ))}
                    </select>
                </div>

                <div className='form-group'>
                    <label className='form-label'>Business Postcode</label>
                    <input
                        className='form-control'
                        type='text'
                        id='business_postcode'
                        value={business_postcode}
                        onChange={onMutate}
                        maxLength='4'
                        minLength='4'
                        required
                    />
                </div>

                <div className='form-group'>
                    <label className='form-label'>Has Postal Address</label>
                    <input
                        className='form-checkbox'
                        type='checkbox'
                        id='postal_check'
                        value={postal_check}
                        onChange={onMutate}
                    />
                </div>

                {(postal_check) && (
                    <>
                        <div className='form-group'>
                            <label className='form-label'>Postal Address</label>
                            <input
                                className='form-control'
                                type='text'
                                id='postal_address'
                                value={postal_address}
                                onChange={onMutate}
                                required
                            />
                        </div>

                        <div className='form-group'>
                            <label className='form-label'>Postal Suburb</label>
                            <input
                                className='form-control'
                                type='text'
                                id='postal_suburb'
                                value={postal_suburb}
                                onChange={onMutate}
                                required
                            />
                        </div>

                        <div className='form-group'>
                            <label className='form-label'>Postal State</label>
                            <select
                                className='form-control'
                                id='postal_state'
                                value={postal_state}
                                onChange={onMutate}
                                required
                            >
                                {states.map((state, index) => (
                                    <option key={index} value={state}>{state}</option>
                                ))}
                            </select>
                        </div>

                        <div className='form-group'>
                            <label className='form-label'>Postal Postcode</label>
                            <input
                                className='form-control'
                                type='text'
                                id='postal_postcode'
                                value={postal_postcode}
                                onChange={onMutate}
                                maxLength='4'
                                minLength='4'
                                required
                            />
                        </div>
                    </>
                )}

                <button type='submit' className='btn btn-info'>
                    Create
                </button>
            </form>
        </>
        
    )
}

export default CreateUser
